// Components
import { IFormInstance } from '@/components';
import { Skeleton } from '@/ui';
import { StyledForm } from './ProductSeoFormStyles';

// Modules
import { MetaTagHints, MetaTagsTabs } from '@/modules/MetaTags';

// Models
import { SupportedLocales } from '@/models/localization.model';

// Helpers
import { TProductSeoFormValues } from '../../helpers';
import { useSeoValidationRules } from '../../hooks';

const initialLocale = {
  [SupportedLocales.UK]: { seo_title: '', seo_description: '', seo_keywords: [] },
  [SupportedLocales.RU]: { seo_title: '', seo_description: '', seo_keywords: [] },
};

interface IProductMainInfoForm {
  handleSubmit: (values: TProductSeoFormValues) => void;
  isLoading: boolean;
  formInstance: IFormInstance;
  handleValuesChange: () => void;
}

const ProductSeoForm = ({ handleSubmit, isLoading, formInstance, handleValuesChange }: IProductMainInfoForm) => {
  const rules = useSeoValidationRules();
  if (isLoading) return <Skeleton />;

  return (
    <StyledForm
      initialValues={{ locale: initialLocale }}
      onFinish={handleSubmit}
      form={formInstance}
      onValuesChange={handleValuesChange}
    >
      <MetaTagsTabs hint={MetaTagHints.PRODUCTS} rules={rules} />
    </StyledForm>
  );
};

export default ProductSeoForm;
